import { render } from "./FormTextarea.vue?vue&type=template&id=5397af96&ts=true"
import script from "./FormTextarea.vue?vue&type=script&lang=ts"
export * from "./FormTextarea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__